import Vue from 'vue'
import Vuex from 'vuex'
import pkg from 'package'
import * as actions from './actions'
import * as getters from './getters'

import app from './modules/app'
import menu from './modules/menu'
import project from './project'

Vue.use(Vuex)

const store = new Vuex.Store({
  strict: false,
  actions,
  getters,
  modules: {
    project,
    app,
    menu
  },
  state: {
    pkg
  },
  mutations: {
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js